export default [

  {
    path: "/invoices/list",
    name: "invoices-list",
    component: () => import("@/views/invoice/invoices-list/invoicesList.vue"),
    meta: {
      action: ['read', 'read_all'], 
      resource: "invoices",
    },
  },
  {
    path: "/invoice/edit/:id",
    name: "invoice-edit",
    component: () => import("@/views/invoice/invoice-edit/invoiceEdit.vue"),
    meta: {
      action: "update",
      resource: "invoices",
    },
  },
  {
    path: "/invoice/copy/:id",
    name: "invoice-copy",
    component: () => import("@/views/invoice/invoice-edit/invoiceEdit.vue"),
    meta: {
      action: "create",
      resource: "invoices",
    },
  },
  {
    path: "/invoice/create",
    name: "invoice-create",
    component: () => import("@/views/invoice/invoice-edit/invoiceEdit.vue"),
    meta: {
      action: "create",
      resource: "invoices",
    },
  },
  {
    path: '/invoices/preview/:id',
    name: 'invoices-preview',
    component: () => import('@/views/invoice/invoices-preview/InvoicesPreview.vue'),
    meta: {
      action: 'print',
      resource: 'invoices',
    },
  },
]